import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  children: React.ReactNode;
  pullout: string | null;
  isArticle: boolean;
}

const Quote = styled.blockquote`
  ${typography.bodyEditorial}
  font-weight: 500;
`;

export const TextWithPullOut = ({ children, pullout, isArticle }: IProps) => {
  return (
    <SliceWrapper
      left={children}
      right={<Quote>{pullout}</Quote>}
      isArticle={isArticle}
    />
  );
};
